import { render, staticRenderFns } from "./instructions.vue?vue&type=template&id=d947e0fa"
import script from "./instructions.vue?vue&type=script&lang=js"
export * from "./instructions.vue?vue&type=script&lang=js"
import style0 from "./instructions.vue?vue&type=style&index=0&id=d947e0fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports